const sevenkSearchCollectionRoutes = {
  'athletico paranaense': '/collections/menu-athletico-paranaense',
  'atletico paranaense': '/collections/menu-athletico-paranaense',
  'atletico mineiro': '/collections/menu-atletico-mineiro',
  'atletico mg': '/collections/menu-atletico-mineiro',
  'bahia': '/collections/menu-bahia',
  'botafogo': '/collections/menu-botafogo',
  'chapecoense': '/collections/menu-chapecoense',
  'corinthians': '/collections/menu-corinthians',
  'sport club corinthians paulista': '/collections/menu-corinthians',
  'coritiba': '/collections/menu-coritiba',
  'cruzeiro': '/collections/menu-cruzeiro',
  'flamengo': '/collections/menu-flamengo',
  'fluminense': '/collections/menu-fluminense',
  'gremio': '/collections/menu-gremio',
  'internacional': '/collections/menu-internacional',
  'mirassol': '/collections/menu-mirassol',
  'palmeiras': '/collections/menu-palmeiras',
  'red bull bragantino': '/collections/menu-red-bull-bragantino',
  'bragantino': '/collections/menu-red-bull-bragantino',
  'remo': '/collections/menu-remo',
  'santos': '/collections/menu-santos',
  'sao paulo': '/collections/menu-sao-paulo',
  'sao paulo fc': '/collections/menu-sao-paulo',
  'sao paulo futebol clube': '/collections/menu-sao-paulo',
  'spfc': '/collections/menu-sao-paulo',
  'vasco': '/collections/menu-vasco-da-gama',
  'vasco da gama': '/collections/menu-vasco-da-gama',
  'vitoria': '/collections/menu-vitoria',
};

function sevenkNormalizeSearchTerm(value) {
  return value
    .trim()
    .toLocaleLowerCase('pt-BR')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

function sevenkExactSearchRoute(value) {
  return sevenkSearchCollectionRoutes[sevenkNormalizeSearchTerm(value)] || '';
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  onFormSubmit(event) {
    const route = sevenkExactSearchRoute(this.input.value);
    if (!route) return;

    event.preventDefault();
    window.location.assign(route);
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

if (window.location.pathname.replace(/\/$/, '') === '/search') {
  const exactRoute = sevenkExactSearchRoute(new URLSearchParams(window.location.search).get('q') || '');
  if (exactRoute) window.location.replace(exactRoute);
}
